<template>
  <div class="list">
    <div 
      class="list-item" 
      v-for="item in list"
      :key="item.value"
      :class="( Array.isArray(value)?value.includes(item.value):value===item.value)?'active':''"
      @click="handleClick(item)"
    >
      <p>{{item.label}}</p>
      <span v-if="!!label">{{label}}:{{item.num*base}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WkListCheck',
  props: {
    value:{
      type:  [String, Array, Number]
    },
    list: {
      type: Array,
      default: ()=> []
    },
    label: {
      type: String,
      default: ''
    },
    beforeChange: Function,
    base: {
      type: Number,
      default: 1
    }
  },
  methods: {
    handleClick(data) {
      if (Array.isArray(this.value)) {
        let arr = []
        if (this.value.includes(data.value)) {
          arr = this.value.filter(v=> v!==data.value)
        }else {
          arr = [...this.value, data.value]
        }
        this.$emit('input', arr)
        this.$emit('change', arr);        
        
      }else {
        // 新增确认回调触发
       if (typeof this.beforeChange === 'function' && this.value !== data.value ) {
        this.beforeChange(data.value, ()=> {
          this.$emit('change', data.value)
          this.$emit('input', data.value)
        })
       }else {
        if (this.value !== data.value) {
          this.$emit('change', data.value)
        }
        this.$emit('input', data.value)
       }
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
  .list {
    white-space: nowrap;
    overflow: auto;
    &-item {
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      border-left: 1px solid #ccc;
      padding: 4px 20px;
      font-size: 12px;
      line-height: 1;
      cursor: pointer;
      text-align: center;
      display: inline-block;
      &:last-child {
        border-right: 1px solid #ccc;
      }
      &.active {
         border-top: 1px solid #409eff;
        border-bottom: 1px solid #409eff;
        border-left: 1px solid #409eff;
        background: #def5ff;
        color: #409eff;
        border-right: 1px solid #409eff;
        span {
          color: #409eff;
        }
      }
      
      span {
        color: #aaa;
      }
    }
  }
</style>